import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../http/query-client';
import {useTrans} from '../i18n/use-trans';
import {BackendResponse} from '../http/backend-response/backend-response';
import {toast} from '../ui/toast/toast';
import {message} from '../i18n/message';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '../errors/on-form-query-error';
import {useNavigate} from '../utils/hooks/use-navigate';

/**
 * Изменено: 2026-08-05 — контактная форма создаёт тикет поддержки, залогиненного ведём в его тред.
 */
interface Response extends BackendResponse {
  ticket: {
    id: number;
    number: number;
    has_account: boolean;
  };
}

export interface ContactPagePayload {
  name: string;
  email: string;
  message: string;
}

export function useSubmitContactForm(form: UseFormReturn<ContactPagePayload>) {
  const {trans} = useTrans();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (props: ContactPagePayload) => submitContactForm(props),
    onSuccess: response => {
      const ticket = response.ticket;
      if (ticket?.has_account) {
        toast(
          trans(
            message('Ticket #:number created', {
              values: {number: ticket.number},
            }),
          ),
        );
        navigate(`/dashboard/support/${ticket.id}`);
        return;
      }

      toast(trans(message('Thanks! We will reply to your email.')));
      navigate('/');
    },
    onError: err => onFormQueryError(err, form),
  });
}

function submitContactForm(payload: ContactPagePayload): Promise<Response> {
  return apiClient.post('contact-page', payload).then(r => r.data);
}
